import { Injectable } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment as _env } from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RestsService {
  constructor(private http: HttpClient, private user: AuthService) { }

  getPermessi() {
    return new Promise((resolve, reject) => {
      resolve(true); 
      /*
if(_env.debug) console.log('-------------- IN: '  + _env.services_rest_url + 'getPermessi/'+this.user.getUsername());
      this.http.get(_env.services_rest_url + 'getPermessi/'+this.user.getUsername())
          .subscribe( res => {
              //this.isAuthenticated = res['isAuthenticated'];
              if(_env.debug) console.log('-------------- RES: '  + JSON.stringify(res));
              resolve(true); });
            */
    })
  }

  getPermessiRisorse() {
    return new Promise((resolve, reject) => {
      resolve(true); 
            
      /*
      this.http.get(_env.services_rest_url + 'getPermessiRisorse/'+this.user.getUsername())
          .subscribe( res => {
              //this.isAuthenticated = res['isAuthenticated'];
              //https://test.sardegnasira.it/mgu/rest/metodi/getUtente/utenteadmin
              if(_env.debug) console.log('-------------- RES: '  + JSON.stringify(res));
              resolve(true); });

              */
    })
  }


}
